module.exports = __webpack_public_path__ + "media/images/social/youtube-eb4bc340c3c4d0d6572b25f95ddef9a9.svg";